import { render, staticRenderFns } from "./AmountWidget.vue?vue&type=template&id=81ad81c0&scoped=true&"
import script from "./AmountWidget.vue?vue&type=script&lang=js&"
export * from "./AmountWidget.vue?vue&type=script&lang=js&"
import style0 from "./AmountWidget.vue?vue&type=style&index=0&id=81ad81c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ad81c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCol,VDivider,VIcon,VRow,VSkeletonLoader})
